/**
 * VISUAL REQUIRED RULES — MeesterJay 4.1
 *
 * PHASE 3 MIGRATION: Now delegates to Policy Engine for visual requirements.
 * The canonical source is defaultPolicy.ts visual.requiredFamilies.
 * This file is a thin compatibility wrapper.
 *
 * ARCHITECTURE v4.0 — Phase 3, Step 3.2
 *
 * @deprecated Use familyRequiresVisual() from governance/pipeline/policyEngine instead.
 */

import {
  familyRequiresVisual,
  getPolicy,
} from '../governance/pipeline/policyEngine'

/**
 * @deprecated Use getPolicy().visual.requiredFamilies instead.
 * Kept for backward compatibility during Phase 3 migration.
 */
export const VISUAL_REQUIRED_FAMILIES = new Set<string>(
  getPolicy().visual.requiredFamilies,
)

/**
 * Check if a family requires a visual aid.
 * @deprecated Use familyRequiresVisual() from governance/pipeline/policyEngine instead.
 */
export function requiresVisual(familyId: string): boolean {
  return familyRequiresVisual(familyId)
}
